export default {
  'menu.admin.mailbox': '邮件收取',
  'menu.mailbox': '邮件',
  'mailbox.empty.no_accounts': '还没有配置任何收件信箱。',
  'mailbox.empty.go_configure': '去配置信箱',

  'mailbox.field.name': '名称',
  'mailbox.field.email': '邮箱地址',
  'mailbox.field.provider': '服务商',
  'mailbox.field.auth_type': '认证方式',
  'mailbox.field.secret': '应用专用密码',
  'mailbox.auth.oauth_google': 'Google 授权',
  'mailbox.auth.oauth_microsoft': 'Microsoft 授权',
  'mailbox.auth.password': '应用专用密码（IMAP）',
  'mailbox.delete': '删除',
  'mailbox.delete_confirm': '删除这个信箱？之后不再收信，已收取的邮件仍保留在 inbox 中。',
  'mailbox.change_secret': '修改密码',
  'mailbox.will_authorize': '信箱创建后会引导你完成授权。',
  'mailbox.secret_help': '邮箱服务商生成的应用专用密码 / 授权码，不是登录密码。',
  'mailbox.field.since_days': '首次回溯',
  'mailbox.since_days_value': '{days} 天',
  'mailbox.since_days_help':
    '第一次收信往回取多少天。之后按 UID 游标增量收取，不再受它限制。绑一个已经用了一阵的信箱时要调大，否则里面的邮件全在窗口之外，一封也收不到。',
  'mailbox.collected_none_first_run':
    '没有收到邮件。这个信箱还没收过信，而首次收信只回溯 {days} 天——如果里面的邮件比这更早，把「首次回溯」调大再收一次。',
  'mailbox.field.folder': '文件夹',
  'mailbox.field.username': 'IMAP 登录名',
  'mailbox.username_help':
    '一般与邮箱地址相同。共享信箱时这里填被读取的那个信箱，而授权用的是另一个账号。',
  'mailbox.field.authorized': '授权状态',
  'mailbox.field.last_collected': '上次收取',
  'mailbox.disabled': '已停用',
  'mailbox.disabled_notice':
    '这个信箱已停用：不再收新邮件，也不再处理里面的邮件；已经收进来的仍然可以查看。要恢复请到 管理 › 邮件收取。',
  'mailbox.field.enabled': '启用',
  'mailbox.field.from': '发件人',
  'mailbox.field.to': '收件人',
  'mailbox.field.subject': '主题',
  'mailbox.field.sent_at': '发送时间',
  'mailbox.field.attachments': '附件',
  'mailbox.field.status': '状态',

  'mailbox.status.all': '全部',
  'mailbox.restore': '恢复',
  'mailbox.ignore': '忽略',
  'mailbox.status.new': '待处理',
  'mailbox.status.ignored': '已忽略',

  'mailbox.add_account': '添加信箱',
  'mailbox.edit_account': '编辑信箱',
  'mailbox.edit_immutable_help':
    '邮箱地址、服务商和认证方式建号后不能改——换掉会让已存的凭证和同步游标全部失配，那种情况请新建一个信箱。要换密码请用「改密码」。',
  'mailbox.authorize': '授权',
  'mailbox.reauthorize': '重新授权',
  'mailbox.authorized': '授权成功',
  'mailbox.not_authorized': '未授权',
  'mailbox.test': '测试连接',
  'mailbox.testing': '正在测试连接…',
  'mailbox.test_ok': '连接正常',
  'mailbox.messages_total': '封邮件',
  'mailbox.collect_now': '立即收取',
  'mailbox.collecting': '正在收取…',
  'mailbox.collected': '新收取邮件',
  'mailbox.attachment_unnamed': '(未命名文件)',
  'mailbox.no_subject': '(无主题)',
  'mailbox.has_errors': '有信箱需要处理',
  'mailbox.created_now_authorize': '信箱已创建 —— 点「授权」完成绑定',
  'mailbox.email_help': '要收取的共享信箱。用来授权的那个账号必须对它有 Full Access 权限。',

  'mailbox.field.participants': '往来',
  'mailbox.field.last_activity': '最后往来',
  'mailbox.thread.count': '{count} 封',
  'mailbox.thread.partial':
    '当前筛选下只有 {count} 封；这条会话一共 {total} 封，其余的在别的标签或别的 tab 里。',
  'mailbox.thread.selected': '已选 {threads} 条会话 / {messages} 封',
  'mailbox.thread.empty': '没有符合条件的会话',
  'mailbox.field.labels': '标签',
  'mailbox.label_add': '标签',
  'mailbox.filter_by_label': '按标签筛选',
  'mailbox.add_label_to_selected': '添加标签',
  'mailbox.remove_label': '移除标签…',
};
